<template>
  <v-dialog
    v-model="show"
    max-width="400px"
    @click:outside="cancel"
  >
    <v-card>
      <v-card-title>
          <span class="headline">
            Delete audio
          </span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            {{ this.name }} ({{ this.audioId }})
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="cancel"
        >
          Cancel
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="deleteAudio"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>
<script>
export default {
  name: 'AudioDialogDelete',
  props: {
    name: {
      type: String,
      default: 'default',
    },
    audioId: Number,
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },

  mounted() {
  },

  methods: {

    deleteAudio() {
      this.$requestHelpers
        .delete(`api/admin/audio/${this.audioId}`)
        .then(() => {
          this.$emit('deleted', true);
        })
        .catch(() => {
          this.$emit('deleted', false);
        });
    },

    cancel() {
      this.$emit('update:show', false);
    },
  },

  watch: {
    audioId(val) {
      this.id = val;
    },
  },
};
</script>
